

















import Vue from 'vue'
import Component from 'vue-class-component'
import { StringMap } from '../utils/map'
import { loggerFor } from '../utils/logger'
import { DialogService } from '@/shared/dialog/dialog-service'
import { Injector } from '@/config/dependency-injection'
import RespondecoDialog from '@/main/dialog.vue'
import RespondecoDialogButtons from '@/main/dialog-buttons.vue'
import RespondecoDialogButton from '@/main/dialog-button.vue'

@Component({
  components: { RespondecoDialogButton, RespondecoDialogButtons, RespondecoDialog },
})
export default class InfoDialog extends Vue {
  public static dialogName = 'info-dialog'

  public text = ''
  public title = ''

  private dialogService = Injector.get(DialogService)
  private logger = loggerFor('InfoDialog')

  public beforeOpen(event: StringMap<any>): void {
    this.logger.debug('Opening confirmation dialog')

    if (event.params.text) {
      this.text = event.params.text
    }

    if (event.params.title) {
      this.title = event.params.title
    }
  }

  public close() {
    this.dialogService.hide(InfoDialog)
  }
}
